export type INDICATION_REQUEST_LIST_PRINT_TYPE = 'GROUP' | 'SEPARATE';

export const LOCAL_STORAGE_INDICATION_LIST_PRINT_TYPE = 'LOCAL_STORAGE_INDICATION_LIST_PRINT_TYPE';

export const LOCAL_STORAGE_INDICATION_LIST_COMPACT_MODE = 'LOCAL_STORAGE_INDICATION_LIST_COMPACT_MODE';
